import Nl2br from './Nl2br'

export default Nl2br
